module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-101-min.7c865755.jpg";